<template>
  <div >
    <div class="login-background"></div>
    <div class="login-other">
      <el-form :rules="rulesL" ref="loginForm" :model="loginForm" class="loginContainer">
        <H3 class="loginTitle">小程序后台管理</H3>
        <el-form-item prop="name">
          <el-input prefix-icon="el-icon-user-solid" size="normal" type="text" v-model="loginForm.account"
            placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item prop="pwd">
          <el-input prefix-icon="el-icon-lock" size="normal" type="password" v-model="loginForm.password"
            placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-button size="normal" :disabled="disabled" type="primary" style="width: 100%;margin-top: 15px;"
          @click="submitLogin">登
          录</el-button>
      </el-form>
    </div>


  </div>
</template>

<script>
import { loginAdm } from '@/api';
import socket from '@/utils/websocket';
export default {
  name: "Login",
  data() {
    return {
      loginForm: {
        account: '',
        password: ''
      },
      disabled: false,
      rulesL: {
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      }
    }
  },
  methods: {
    submitLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.disabled = true;
          const loading = this.$loading({ lock: true, text: '登录中...', background: 'rgba(255, 255, 255, 0.6)' });
          loginAdm(this.loginForm).then((res) => {
            loading.close();
            this.disabled = false;
            var code = res.code;
            if (code != 0) {
              this.$message.warning(res.msg);
              return false;
            }
            this.$cookies.set("token", res.data, { expires: 1 });
            this.$message.success('登录成功');
            socket.createSocket(this.$base.ws);
            // 申请浏览器桌面通知权限，用于后台订单提醒
            if (socket.ensureDesktopPermission) socket.ensureDesktopPermission();
            this.$router.push('/dashboard').catch(() => { });
          }).catch(() => {
            loading.close();
            this.disabled = false;
          });

        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
.login-background {
  /* background: linear-gradient(-180deg, #dcf2e6 0%, #ffffff 100%); */
  background-image: url(../assets/img/bj.jpg);
  width: 100%;
  height: 100%;
  /**宽高100%是为了图片铺满屏幕 */
  z-index: -1;
  position: absolute;
  background-size: cover;
  background-position: center;
}

.login-other {
  z-index: 1;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.loginContainer {
  border-radius: 10px;
  background-clip: padding-box;
  width: 380px;
  max-width: calc(100vw - 40px);
  padding: 15px 35px 35px 35px;
  background: #fefefe;
  border: 1px solid #eaeaea;
}

.loginTitle {
  margin: 15px auto 20px auto;
  text-align: center;
  color: #000;
}

.loginRemember {
  text-align: left;
  margin: 0 0 15px 0;
}

.bind_code {
  position: relative;
}

.bind_code .el-input__inner {
  width: 328px;
  height: 44px;
  background: #f7f7f7;
  border-radius: 4px;
  border: 1px solid #e4e4e4;
  outline: none;
  padding: 0 100px 0 10px;
}

.bind_code .code /deep/.el-input__suffix {
  right: 97px;
}

.bind_code .el-button {
  border: 0;
  background: none;
  padding: 0;
  border-radius: 0;
}

.bind_code.pic {
  width: 80px;
  height: 25px;
  border-left: none !important;
}

.bind_code .bind_code_gain {
  position: absolute;
  top: calc(50% - 9px);
  right: 10px;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: #20aee5;
  line-height: 18px;
  cursor: pointer;
  padding-left: 10px;
  border-left: 1px solid #d8d8d8;
}

/* 手机端适配 */
@media (max-width: 767px) {
  .loginContainer {
    width: calc(100vw - 40px);
    padding: 15px 20px 25px 20px;
  }
  .bind_code .el-input__inner {
    width: 100%;
  }
}
</style>